(function(){
  'use strict';
  if(window.__CL_FULL_JOURNEY_V1__) return;
  window.__CL_FULL_JOURNEY_V1__=true;

  var THEME_ID='207398502686';
  var SHOP='j0pgjz-sq.myshopify.com';
  var HOSTS=['chris-lake.com','www.chris-lake.com'];
  var COMPANY_ID='TGB9tG';
  var SESSION_KEY='cl_full_journey_session_v1';
  var ATTR_KEY='cl_full_journey_attribution_v1';
  var QA_KEY='cl_full_journey_qa_v1';
  var ctx=window.__CL_FULL_CONTEXT__||{};
  var started=false,visibleSeconds=0,maxScroll=0,checkoutIntent=false;
  var once=Object.create(null);
  var sectionState=new Map();
  var hoverTimers=new WeakMap();
  var seenCards=new WeakSet();
  var cartState={quantity:0,value:0,currency:'',lineCount:0};
  var pendingCartBefore=null;
  var MAX_AGE=90*24*60*60*1000;
  var UTM_KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'];

  function allowed(){
    try{
      var p=window.Shopify&&window.Shopify.customerPrivacy;
      return !!(p&&typeof p.analyticsProcessingAllowed==='function'&&p.analyticsProcessingAllowed()===true);
    }catch(_){return false;}
  }
  function qaMode(){
    try{
      var s=window.Shopify,u=new URL(location.href);
      if(!(allowed()&&s&&s.shop===SHOP&&s.theme&&String(s.theme.id)===THEME_ID&&s.theme.role!=='main'&&
        HOSTS.indexOf(location.hostname)!==-1&&location.protocol==='https:'&&!s.designMode&&!s.visualPreviewMode&&!s.inspectMode))return false;
      if(u.searchParams.get('cl_tracking_qa')==='1'){
        try{sessionStorage.setItem(QA_KEY,'1');}catch(_){}
      }
      try{return sessionStorage.getItem(QA_KEY)==='1';}catch(_){return false;}
    }catch(_){return false;}
  }
  function production(){
    try{
      var s=window.Shopify,u=new URL(location.href);
      var live=!!(allowed()&&s&&s.shop===SHOP&&s.theme&&String(s.theme.id)===THEME_ID&&s.theme.role==='main'&&
        HOSTS.indexOf(location.hostname)!==-1&&location.protocol==='https:'&&!s.designMode&&!s.visualPreviewMode&&!s.inspectMode&&
        !['preview_theme_id','preview','_fd','preview_script_id'].some(function(k){return u.searchParams.has(k);}));
      return live||qaMode();
    }catch(_){return false;}
  }
  function safe(v,n){return String(v==null?'':v).replace(/[\u0000-\u001F<>]/g,'').trim().slice(0,n||240);}
  function uid(){try{return crypto.randomUUID();}catch(_){return 'cl-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,12);}}
  function read(storage,key,fallback){try{return JSON.parse(storage.getItem(key)||'')||fallback;}catch(_){return fallback;}}
  function write(storage,key,value){try{storage.setItem(key,JSON.stringify(value));}catch(_){}}

  function session(){
    var s=read(sessionStorage,SESSION_KEY,null);
    if(!s||!s.id)s={id:uid(),started_at:new Date().toISOString(),first_path:location.pathname||'/',page_index:0,current_path:'',previous_path:''};
    if(!s.page_counted_for||s.page_counted_for!==location.pathname){
      s.page_index=Number(s.page_index||0)+1;
      s.previous_path=s.current_path||'';
      s.current_path=location.pathname||'/';
      s.page_counted_for=location.pathname;
      s.last_seen_at=new Date().toISOString();
      write(sessionStorage,SESSION_KEY,s);
    }
    return s;
  }

  function attribution(){
    var now=Date.now(),a=read(localStorage,ATTR_KEY,null);
    if(!a||!a.createdAt||now-a.createdAt>MAX_AGE)a={createdAt:now,first:{},latest:{},landing_path:location.pathname||'/'};
    var q=new URLSearchParams(location.search),cur={};
    UTM_KEYS.forEach(function(k){var v=safe(q.get(k),100);if(v)cur[k]=v;});
    // Recover a recent missed landing only from this store's referrer when no campaign is known.
    // Never replace an explicit current campaign or a persisted first/latest touch.
    if(!Object.keys(cur).length&&!Object.keys(a.first||{}).length&&!Object.keys(a.latest||{}).length&&
        now-a.createdAt>=0&&now-a.createdAt<=30*60*1000){
      try{
        var ref=new URL(a.first_referrer||document.referrer||'',location.href);
        if(ref.origin===location.origin){
          UTM_KEYS.forEach(function(k){var v=safe(ref.searchParams.get(k),100);if(v)cur[k]=v;});
          if(Object.keys(cur).length)a.attribution_recovered_from='same_origin_referrer';
        }
      }catch(_){}
    }
    if(Object.keys(cur).length){
      if(!Object.keys(a.first||{}).length)a.first=Object.assign({},cur);
      a.latest=Object.assign({},cur);a.touched=now;
    }
    // Keep campaign parameters, but remove identity/recovery tokens from new and stored referrers.
    if(a.first_referrer||document.referrer)a.first_referrer=cleanUrl(a.first_referrer||document.referrer);
    write(localStorage,ATTR_KEY,a);
    var out={landing_path:a.landing_path||'/',first_referrer:a.first_referrer||''};
    if(a.attribution_recovered_from)out.attribution_recovered_from=a.attribution_recovered_from;
    UTM_KEYS.forEach(function(k){out['first_'+k]=(a.first&&a.first[k])||'';out['latest_'+k]=(a.latest&&a.latest[k])||'';});
    return out;
  }

  var sessionMeta={id:'',started_at:'',first_path:'',page_index:0,previous_path:''};
  var attrMeta={};
  // BFCM email-origin attribution is bound to the present tab/session; no consent is implied.
  var BFCM_SESSION_KEY='cl_bfcm_2026_email_origin_v1';
  function bfcmEmailOrigin(){
    try{
      var query=new URLSearchParams(location.search);
      var hasCampaignQuery=['utm_source','utm_medium','utm_campaign'].some(function(k){return query.has(k);});
      if(hasCampaignQuery){
        if(query.get('utm_source')==='klaviyo'&&query.get('utm_medium')==='email'&&query.get('utm_campaign')==='cl_bfcm_2026'){
          sessionStorage.setItem(BFCM_SESSION_KEY,JSON.stringify({id:sessionMeta.id,at:Date.now()}));
        }else{sessionStorage.removeItem(BFCM_SESSION_KEY);}
      }
      var state=read(sessionStorage,BFCM_SESSION_KEY,null),age=Date.now()-Number(state&&state.at);
      return !!(state&&state.id===sessionMeta.id&&Number.isFinite(age)&&age>=0&&age<=3600000);
    }catch(_){return false;}
  }

  function pageType(){
    var p=location.pathname.toLowerCase();
    if(p==='/'||p==='')return 'home';
    if(/^\/products\//.test(p))return 'product';
    if(/^\/collections\//.test(p))return 'collection';
    if(/^\/pages\//.test(p))return 'page';
    if(/^\/blogs\//.test(p))return 'article';
    if(/^\/search/.test(p))return 'search';
    if(/^\/cart/.test(p))return 'cart';
    return 'page';
  }
  function interest(){
    var p=location.pathname.toLowerCase();
    if(/head-trip/.test(p))return 'head_trip';
    if(/collection-003|stay-updated-1/.test(p))return 'collection_003';
    if(/^\/products\//.test(p)||/^\/collections\//.test(p)||/\/shop/.test(p))return 'merch';
    if(/\/music|release|vinyl/.test(p))return 'music';
    if(/\/live|tour|show|ticket|event-/.test(p))return 'tickets_shows';
    if(/\/join|network/.test(p))return 'network';
    if(/archive/.test(p))return 'archive';
    return 'general';
  }
  function campaign(){
    var p=location.pathname.toLowerCase();
    if(/head-trip/.test(p))return 'head_trip';
    if(/collection-003|stay-updated-1/.test(p))return 'collection_003';
    if(/\/music|release|vinyl/.test(p))return 'music';
    if(/\/live|tour|show|ticket|event-/.test(p))return 'tickets';
    if(/\/join|network/.test(p))return 'network';
    return 'general';
  }
  function destinationInterest(path){
    var p=String(path||'').toLowerCase();
    if(/head-trip/.test(p))return 'head_trip';
    if(/collection-003|stay-updated-1/.test(p))return 'collection_003';
    if(/^\/products\//.test(p)||/^\/collections\//.test(p)||/\/shop/.test(p))return 'merch';
    if(/\/music|release|vinyl/.test(p))return 'music';
    if(/\/live|tour|show|ticket|event-/.test(p))return 'tickets_shows';
    if(/\/join|network/.test(p))return 'network';
    if(/archive/.test(p))return 'archive';
    return 'general';
  }
  function externalPlatform(host){
    host=String(host||'').toLowerCase();
    if(/instagram\.com/.test(host))return 'instagram';
    if(/(?:^|\.)x\.com$|twitter\.com/.test(host))return 'x';
    if(/tiktok\.com/.test(host))return 'tiktok';
    if(/facebook\.com/.test(host))return 'facebook';
    if(/youtube\.com|youtu\.be/.test(host))return 'youtube';
    if(/twitch\.tv/.test(host))return 'twitch';
    if(/spotify\.com/.test(host))return 'spotify';
    if(/music\.apple\.com/.test(host))return 'apple_music';
    if(/soundcloud\.com/.test(host))return 'soundcloud';
    if(/discord\.gg|discord\.com/.test(host))return 'discord';
    if(/axs\.com/.test(host))return 'axs';
    if(/ticketmaster\.com/.test(host))return 'ticketmaster';
    if(/dice\.fm/.test(host))return 'dice';
    if(/laylo\.com/.test(host))return 'laylo';
    return host.replace(/^www\./,'')||'external';
  }
  function destinationCategory(host,path){
    var p=externalPlatform(host);
    if(['spotify','apple_music','soundcloud'].indexOf(p)!==-1)return 'music_platform';
    if(['instagram','x','tiktok','facebook','youtube','twitch','discord'].indexOf(p)!==-1)return 'social_platform';
    if(['axs','ticketmaster','dice'].indexOf(p)!==-1||/ticket|tickets/i.test(String(path||'')))return 'ticketing';
    if(p==='laylo')return 'signup_access';
    return 'external';
  }
  function menuContext(el){
    if(!(el instanceof Element))return null;
    var nav=el.closest('nav,[role="navigation"],header,footer,[class*="menu" i],[id*="menu" i],[class*="drawer" i]');
    if(!nav)return null;
    var loc=el.closest('footer')?'footer':(el.closest('[class*="mobile" i],[class*="drawer" i]')?'mobile_menu':'header');
    var details=el.closest('details'),summary=details&&details.querySelector(':scope > summary');
    var title=safe((nav.getAttribute&&nav.getAttribute('aria-label'))||(summary&&summary.textContent)||nav.id||nav.className||loc,120);
    return {menu_location:loc,menu_title:title,menu_item:safe(el.getAttribute('aria-label')||el.textContent,160)};
  }
  function productCategory(){
    var raw=((ctx.product&&ctx.product.product_type)||'')+' '+((ctx.product&&ctx.product.title)||'')+' '+((ctx.collection&&ctx.collection.handle)||'')+' '+location.pathname;
    raw=raw.toLowerCase();
    if(/vinyl|record/.test(raw))return 'vinyl';
    if(/hoodie|sweatshirt|crewneck/.test(raw))return 'hoodies';
    if(/tee|t-shirt|tshirt|shirt/.test(raw))return 'tees';
    if(/hat|cap|bandana|accessor|poster|sticker|bag|sock/.test(raw))return 'accessories';
    return /^\/products\//.test(location.pathname)?'merch':'';
  }
  function acquisitionSource(){
    var source=attrMeta.latest_utm_source||attrMeta.first_utm_source||'';
    if(source)return source;
    var ref=attrMeta.first_referrer||document.referrer||'';
    if(ref){try{return new URL(ref,location.href).hostname.replace(/^www\./,'')||'referral';}catch(_){}}
    return 'direct';
  }
  function safeSearchQuery(value){
    var q=safe(value,160);
    if(!q)return '';
    if(/[^\s@]+@[^\s@]+\.[^\s@]+/.test(q))return '[redacted]';
    if(/(?:\+?\d[\d\s().-]{7,}\d)/.test(q))return '[redacted]';
    return q;
  }
  function cleanUrl(raw){
    try{
      var u=new URL(raw||location.href,location.href);
      if(u.protocol!=='https:'||u.username||u.password)return '';
      var arr=[];UTM_KEYS.forEach(function(k){var v=safe(u.searchParams.get(k),100);if(v)arr.push(encodeURIComponent(k)+'='+encodeURIComponent(v));});
      return u.origin+u.pathname+(arr.length?'?'+arr.join('&'):'');
    }catch(_){return '';}
  }
  function locationLabel(el){
    if(!(el instanceof Element))return 'unknown';
    if(el.closest('header'))return 'header';
    if(el.closest('footer'))return 'footer';
    if(el.closest('[id*="cart"],[class*="cart"]'))return 'cart';
    if(el.closest('[class*="product-card"],article,li'))return 'product_card';
    if(el.closest('[class*="search"],form[action*="/search"]'))return 'search';
    return pageType();
  }
  function base(extra){
    var b={
      tracking_version:'cl_full_journey_v4',
      brand:'Chris Lake',
      source_site:'chris-lake.com',
      session_id:sessionMeta.id||'',
      session_start_timestamp:sessionMeta.started_at||'',
      session_started_at:sessionMeta.started_at||'',
      page_index:Number(sessionMeta.page_index||0),
      session_page_index:Number(sessionMeta.page_index||0),
      first_page:sessionMeta.first_path||'',
      session_first_path:sessionMeta.first_path||'',
      previous_page:sessionMeta.previous_path||'',
      previous_path:sessionMeta.previous_path||'',
      current_page:location.pathname||'/',
      page_path:location.pathname||'/',
      complete_page_url:cleanUrl(location.href),
      page_url:cleanUrl(location.href),
      page_title:safe(document.title,200),
      page_type:pageType(),
      page_handle:(ctx.page&&ctx.page.handle)||'',
      referrer:cleanUrl(document.referrer),
      acquisition_source:acquisitionSource(),
      first_touch_source:attrMeta.first_utm_source||acquisitionSource(),
      latest_touch_source:attrMeta.latest_utm_source||attrMeta.first_utm_source||acquisitionSource(),
      browser_timezone:(function(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone||'';}catch(_){return '';}})(),
      browser_locale:(navigator.language||'').slice(0,32),
      shopify_market_country_code:(ctx.market&&ctx.market.country_code)||'',
      shopify_market_country:(ctx.market&&ctx.market.country_name)||'',
      shopify_market_currency:(ctx.market&&ctx.market.currency)||'',
      shopify_locale:(ctx.market&&ctx.market.locale)||'',
      interest:interest(),
      category_preference:productCategory()||interest(),
      campaign:campaign(),
      campaign_drop:campaign(),
      source:'chris-lake.com',
      placement:pageType(),
      collection_id:(ctx.collection&&ctx.collection.id)||'',
      collection_handle:(ctx.collection&&ctx.collection.handle)||'',
      collection_key:(ctx.collection&&ctx.collection.handle)||'',
      collection_name:(ctx.collection&&ctx.collection.title)||'',
      product_id:(ctx.product&&ctx.product.id)||'',
      product_handle:(ctx.product&&ctx.product.handle)||'',
      product_key:(ctx.product&&ctx.product.handle)||'',
      product_name:(ctx.product&&ctx.product.title)||'',
      product_type:(ctx.product&&ctx.product.product_type)||'',
      product_category:productCategory(),
      variant_id:(ctx.product&&ctx.product.variant_id)||'',
      variant_name:(ctx.product&&ctx.product.variant_title)||'',
      sku:(ctx.product&&ctx.product.sku)||'',
      price_cents:Number((ctx.product&&ctx.product.price_cents)||0),
      price:Number((ctx.product&&ctx.product.price_cents)||0)/100,
      currency:(ctx.market&&ctx.market.currency)||''
    };
    UTM_KEYS.forEach(function(k){b[k]=attrMeta['latest_'+k]||attrMeta['first_'+k]||'';});
    Object.keys(attrMeta).forEach(function(k){b[k]=attrMeta[k];});
    if(qaMode())b.qa_mode=true;
    Object.keys(extra||{}).forEach(function(k){b[k]=extra[k];});
    return b;
  }

  function ensureKlaviyo(){
    if(window.klaviyo)return;
    window._klOnsite=window._klOnsite||[];
    try{
      window.klaviyo=new Proxy({},{
        get:function(_t,method){
          if(method==='push')return function(){window._klOnsite.push.apply(window._klOnsite,arguments);};
          return function(){
            var args=Array.prototype.slice.call(arguments);
            return new Promise(function(resolve){window._klOnsite.push([method].concat(args,[resolve]));});
          };
        }
      });
    }catch(_){}
  }
  function loadKlaviyo(){
    var existing='script[data-cl-full-klaviyo],script[src*="static.klaviyo.com/onsite/js/'+COMPANY_ID+'/klaviyo.js"]';
    if(document.querySelector(existing))return;
    var s=document.createElement('script');s.async=true;s.dataset.clFullKlaviyo='1';
    s.src='https://static.klaviyo.com/onsite/js/'+COMPANY_ID+'/klaviyo.js';
    document.head.appendChild(s);
  }
  function identifyKnownCustomer(){
    if(!production())return;
    var c=ctx.customer||{};
    if(!c.logged_in)return;
    var identity={};
    var email=safe(c.email,254);
    var phone=safe(c.phone,40).replace(/[^0-9+]/g,'');
    if(email)identity.email=email;
    if(phone&&/^\+\d{8,15}$/.test(phone))identity.phone_number=phone;
    if(!identity.email&&!identity.phone_number)return;
    if(c.first_name)identity.first_name=safe(c.first_name,100);
    if(c.last_name)identity.last_name=safe(c.last_name,100);
    if(c.city)identity.city=safe(c.city,120);
    if(c.region)identity.region=safe(c.region,120);
    if(c.country)identity.country=safe(c.country,120);
    if(c.zip)identity.zip=safe(c.zip,40);
    identity.shopify_customer_id=safe(c.id,80);
    identity.cl_identity_source='shopify_logged_in_customer';
    identity.cl_identity_verified=true;
    identity.shopify_accepts_marketing=!!c.accepts_marketing;
    ensureKlaviyo();loadKlaviyo();
    try{window.klaviyo.identify(identity);}catch(_){}
  }

  function track(metric,extra,key){
    if(!production())return;
    if(key&&once[key])return;
    if(key)once[key]=true;
    // Unpublished QA traffic must never enter production CRM metrics or trigger customer recovery.
    // Preserve the original event type as an attribute on the isolated QA-only Klaviyo metric.
    var isQA=qaMode();
    var payload=base(extra||{});
    var targetMetric=isQA?'CL | QA | Full Journey Signal | 20261023':metric;
    if(isQA){payload.qa_original_metric=metric;payload.qa_delivery_isolated=true;}
    ensureKlaviyo();loadKlaviyo();
    try{window.klaviyo.track(targetMetric,payload);}catch(_){}
    if(Array.isArray(window.dataLayer))window.dataLayer.push(Object.assign({event:targetMetric},payload));
  }

  function sectionInfo(el){
    return{
      section_id:safe(el.id||el.getAttribute('data-section-id')||'',120),
      section_heading:safe((el.querySelector('h1,h2,h3,[role="heading"]')||{}).textContent||'',160)
    };
  }
  function observeSections(){
    if(typeof IntersectionObserver!=='function')return;
    var els=Array.from(new Set(Array.from(document.querySelectorAll('#mainContent > .shopify-section,#mainContent section[id],#mainContent [data-section-id]')))).slice(0,40);
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var el=e.target,st=sectionState.get(el)||{started:null,total:0,lastSent:0};
        if(e.isIntersecting&&e.intersectionRatio>=0.25){
          track('CL | Web | Section Viewed',Object.assign(sectionInfo(el),{visibility_ratio:Math.round(e.intersectionRatio*100)}),'sv:'+safe(el.id||sectionInfo(el).section_heading,120));
          if(st.started===null)st.started=performance.now();
        }else if(st.started!==null){
          st.total+=(performance.now()-st.started)/1000;st.started=null;
          if(st.total>=5&&st.total-st.lastSent>=5){st.lastSent=st.total;track('CL | Web | Section Engagement',Object.assign(sectionInfo(el),{section_seconds:Math.round(st.total)}));}
        }
        sectionState.set(el,st);
      });
    },{threshold:[0,0.25,0.5,0.75]});
    els.forEach(function(el){obs.observe(el);});
  }
  function productHandle(el){
    var a=el&&el.closest?el.closest('a[href*="/products/"]'):null;
    if(!a&&el&&el.querySelector)a=el.querySelector('a[href*="/products/"]');
    if(!a)return '';
    try{return new URL(a.href,location.origin).pathname.match(/^\/products\/([^/?#]+)/)[1]||'';}catch(_){return '';}
  }
  function observeCards(){
    if(typeof IntersectionObserver!=='function')return;
    var cards=Array.from(new Set(Array.from(document.querySelectorAll('a[href*="/products/"]')).map(function(a){return a.closest('[class*="product-card"],article,li')||a;}))).slice(0,80);
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting||e.intersectionRatio<0.5||seenCards.has(e.target))return;
        seenCards.add(e.target);
        track('CL | Web | Product Card Impression',{impression_product_handle:productHandle(e.target),impression_location:locationLabel(e.target),visibility_ratio:Math.round(e.intersectionRatio*100)});
      });
    },{threshold:[0.5]});
    cards.forEach(function(card){
      obs.observe(card);
      card.addEventListener('pointerenter',function(){
        if(hoverTimers.has(card))return;
        var timer=setTimeout(function(){track('CL | Web | Product Card Interest',{interest_product_handle:productHandle(card),interest_location:locationLabel(card),hover_seconds:2});hoverTimers.delete(card);},2000);
        hoverTimers.set(card,timer);
      });
      card.addEventListener('pointerleave',function(){var t=hoverTimers.get(card);if(t)clearTimeout(t);hoverTimers.delete(card);});
    });
  }

  function refreshCart(sendView,context){
    if(!window.fetch||!production())return Promise.resolve(null);
    return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;}).then(function(c){
      if(!c)return null;
      var before=cartState.quantity;
      cartState={quantity:Number(c.item_count||0),value:Number(c.total_price||0)/100,currency:c.currency||'USD',lineCount:Array.isArray(c.items)?c.items.length:0};
      if(sendView)track('CL | Web | Cart Viewed',{cart_context:context||pageType(),cart_quantity:cartState.quantity,cart_value:cartState.value,cart_currency:cartState.currency,cart_line_count:cartState.lineCount});
      return {before:before,after:Object.assign({},cartState)};
    }).catch(function(){return null;});
  }

  document.addEventListener('click',function(event){
    var el=event.target&&event.target.closest?event.target.closest('a,button,[role="button"]'):null;
    if(!el)return;
    if(!(el instanceof HTMLAnchorElement)){
      track('CL | Web | CTA Click',{
        cta_text:safe(el.getAttribute('aria-label')||el.textContent,160),
        cta_location:locationLabel(el),
        control_type:(el.getAttribute('role')||el.tagName||'button').toLowerCase()
      });
    }
    if(el instanceof HTMLAnchorElement){
      try{
        var d=new URL(el.href,location.origin),internal=HOSTS.indexOf(d.hostname)!==-1||d.hostname===SHOP;
        var platform=internal?'internal':externalPlatform(d.hostname);
        var p={
          destination_url:cleanUrl(d.href),
          destination_host:d.hostname,
          destination_path:d.pathname,
          destination_interest:destinationInterest(d.pathname),
          destination_platform:platform,
          destination_category:internal?'internal':destinationCategory(d.hostname,d.pathname),
          link_type:internal?'internal':'external',
          cta_text:safe(el.getAttribute('aria-label')||el.textContent,160),
          cta_location:locationLabel(el),
          originating_page:location.pathname||'/'
        };
        p.url=p.destination_url;p.destination=p.destination_url;
        track('CL | Web | Link Click',p);
        track('CL | Web | Page Click',Object.assign({},p,{legacy_page_click:true,event_type:'page_click'}));
        var menu=menuContext(el);
        if(menu)track('CL | Web | Menu Click',Object.assign({},p,menu));
        if(!internal)track('CL | Web | External Link Click',p);
        if(/button|cta|btn/i.test(String(el.className||''))||el.getAttribute('role')==='button'){
          track('CL | Web | CTA Click',Object.assign({},p,{cta_location:locationLabel(el)}));
        }
        var di=p.destination_interest||'general';
        if(/youtube\.com|youtu\.be/i.test(d.hostname)) track('CL | Web | YouTube Click',Object.assign({},p,{event_type:'youtube_click'}));
        if(/laylo\.com/i.test(d.hostname)) track('CL | Web | Laylo Click',Object.assign({},p,{event_type:'laylo_click'}));
        if(/axs\.com|ticketmaster\.com|dice\.fm|ticket|tickets/i.test(d.hostname+d.pathname)) track('CL | Web | Ticket Click',Object.assign({},p,{event_type:'ticket_click',campaign:'tickets',interest:'tickets_shows'}));
        if(di==='music'||/spotify\.com|music\.apple\.com|soundcloud\.com/i.test(d.hostname)) track('CL | Web | Music Click',Object.assign({},p,{event_type:'music_click',interest:'music'}));
        if(di==='tickets_shows'&&!/axs\.com|ticketmaster\.com|dice\.fm|ticket|tickets/i.test(d.hostname+d.pathname)) track('CL | Web | Show Click',Object.assign({},p,{event_type:'show_click',campaign:'tickets',interest:'tickets_shows'}));
        if(di==='network') track('CL | Web | Network Click',Object.assign({},p,{event_type:'network_click',interest:'network'}));
        if(/livestream|live-stream|stream/i.test(d.pathname+' '+p.cta_text)) track('CL | Web | Livestream Click',Object.assign({},p,{event_type:'livestream_click'}));
        if(di==='head_trip'||di==='collection_003') track('CL | Web | Campaign Click',Object.assign({},p,{event_type:'campaign_click',campaign:di}));
        // BFCM email-to-site follow-up QA: real on-site merchandise click, not an email click or consent.
        if(internal && (/^\/products\//.test(d.pathname)||/^\/collections\//.test(d.pathname)||d.pathname==='/cart') &&
            !/head-trip|fan-favorites|collection-003/i.test(d.pathname) && bfcmEmailOrigin()){
          track('CL | Web | Campaign Click',Object.assign({},p,{
            event_type:'campaign_click',campaign:'cl_bfcm_2026',campaign_drop:'cl_bfcm_2026',
            utm_source:'klaviyo',utm_medium:'email',utm_campaign:'cl_bfcm_2026',
            campaign_click_stage:'onsite_merch_navigation',campaign_click_verified_purchase:false
          }), 'clbfcm:'+sessionMeta.id+':'+d.pathname);
        }
        var cm=internal?d.pathname.match(/^\/collections\/([^/?#]+)/):null;
        if(cm)track('CL | Web | Collection Click',Object.assign({},p,{clicked_collection_handle:cm[1],collection_key:cm[1]}));
        var pm=internal?d.pathname.match(/^\/products\/([^/?#]+)/):null;
        if(pm){
          var productNode=el.closest('[data-cl-product-id],[data-product-id]');
          var productId=safe(productNode&&(productNode.getAttribute('data-cl-product-id')||productNode.getAttribute('data-product-id')),80);
          var productTitle=safe(productNode&&productNode.getAttribute('data-cl-product-title'),200);
          track('CL | Web | Product Click',Object.assign({},p,{
            event_type:'product_click',
            clicked_product_handle:pm[1],
            product_handle:pm[1],
            product_key:pm[1],
            product_id:productId||pm[1],
            product_title:productTitle||''
          }));
        }
        if(/discord\.gg|discord\.com/i.test(d.hostname)){
          track('CL | Web | Discord Click',Object.assign({},p,{event_type:'network_discord_clicked',interest:'network',social_host:d.hostname}));
        }
        if(/instagram\.com|x\.com|twitter\.com|tiktok\.com|facebook\.com|youtube\.com|youtu\.be|twitch\.tv|discord\.gg|discord\.com/i.test(d.hostname)){
          track('CL | Web | Social Click',Object.assign({},p,{social_host:d.hostname,social_platform:platform}));
        }
      }catch(_){}
    }
    var checkout=el.closest('a[href*="/checkout"],button[name="checkout"],[data-checkout]');
    if(checkout){checkoutIntent=true;track('CL | Web | Checkout Click',{cta_text:safe(checkout.textContent,160),cta_location:locationLabel(checkout),cart_quantity:cartState.quantity,cart_value:cartState.value,cart_currency:cartState.currency});}
    if(el.closest('a[href="/cart"],a[href*="/cart"],[data-cart],button[aria-label*="cart" i]'))refreshCart(true,'click');
    if(ctx.product&&el.closest('[class*="product-media"],[class*="product-gallery"],media-gallery,img,video')){
      track('CL | Web | Product Media Interaction',{interaction:'control_click',media_target:(el.tagName||'').toLowerCase(),cta_location:locationLabel(el)});
    }
  },true);

  document.addEventListener('liquid-ajax-cart:request-start',function(event){
    var rs=event&&event.detail&&event.detail.requestState||{},type=rs.requestType||'';
    if(['add','change','update','clear'].indexOf(type)!==-1)pendingCartBefore=Object.assign({},cartState);
  });
  document.addEventListener('liquid-ajax-cart:request-end',function(event){
    var rs=event&&event.detail&&event.detail.requestState||{},type=rs.requestType||'',resp=rs.responseData;
    if(['add','change','update','clear'].indexOf(type)===-1)return;
    var before=pendingCartBefore||Object.assign({},cartState);pendingCartBefore=null;
    if(!resp||resp.ok!==true){
      track('CL | Web | Cart Update Failed',{cart_request_type:type,http_status:resp&&resp.status||0,cart_quantity:before.quantity,cart_value:before.value,cart_currency:before.currency});
      return;
    }
    refreshCart(false,type).then(function(snapshot){
      if(!snapshot)return;
      var after=snapshot.after;
      if(type==='add'&&after.quantity>before.quantity){
        track('CL | Web | Added To Cart',{cart_quantity:after.quantity,cart_value:after.value,cart_currency:after.currency,cart_line_count:after.lineCount,added_quantity:Math.max(0,after.quantity-before.quantity)});
      }
      if(type!=='add'&&after.quantity!==before.quantity){
        track('CL | Web | Cart Quantity Updated',{cart_request_type:type,previous_cart_quantity:before.quantity,cart_quantity:after.quantity,cart_value:after.value,cart_currency:after.currency});
        if(after.quantity<before.quantity)track('CL | Web | Removed From Cart',{cart_request_type:type,previous_cart_quantity:before.quantity,cart_quantity:after.quantity,removed_quantity:before.quantity-after.quantity,cart_value:after.value,cart_currency:after.currency});
      }
    });
  });

  document.addEventListener('submit',function(event){
    var f=event.target;if(!(f instanceof HTMLFormElement))return;
    var action=safe(f.getAttribute('action'),200);
    if(/\/cart\/add/.test(action)){
      var fd=new FormData(f);
      track('CL | Web | Add To Cart Click',{submitted_variant_id:safe(fd.get('id'),80),quantity:Number(fd.get('quantity')||1),cta_location:locationLabel(f)});
    }
    if(/\/search/.test(action)||f.querySelector('input[type="search"],input[name="q"]')){
      var input=f.querySelector('input[name="q"],input[type="search"]'),q=safeSearchQuery(input&&input.value);
      if(q){
        var fdSearch=new FormData(f),filters=[];
        fdSearch.forEach(function(v,k){if(/^filter\./.test(k))filters.push(k+'='+safe(v,120));});
        track('CL | Web | Search Submitted',{search_query:q,search_location:locationLabel(f),sort:safe(fdSearch.get('sort_by'),120),filters:filters.join('|')});
      }
    }
  },true);

  document.addEventListener('change',function(event){
    var input=event.target;if(!(input instanceof HTMLInputElement||input instanceof HTMLSelectElement))return;
    var f=input.closest('form');
    if(f&&/\/cart\/add/.test(f.getAttribute('action')||'')){
      var fd=new FormData(f);track('CL | Web | Variant Selected',{control_name:safe(input.name,80),control_value:safe(input.value,120),selected_variant_id:safe(fd.get('id'),80)});
    }
    if(f&&(input.name==='sort_by'||/^filter\./.test(input.name||''))){
      track('CL | Web | Collection Filtered',{filter_name:safe(input.name,120),filter_value:safe(input.value,160),sort:safe(new FormData(f).get('sort_by'),120)});
    }
  },true);


  function observeLegacyCompatibleSignals(){
    window.addEventListener('klaviyoForms',function(event){
      var d=event&&event.detail||{};
      if(d.type!=='submit'||d.companyId!==COMPANY_ID)return;
      track('CL | Web | Form Submitted',{
        event_type:'form_submitted',
        form_id:safe(d.formId,80),
        form_source:'klaviyo',
        cl_full_form_submit:true
      },'form:'+safe(d.formId,80));
    });

    document.addEventListener('change',function(event){
      var el=event.target;
      if(!(el instanceof HTMLInputElement||el instanceof HTMLSelectElement))return;
      var interestValue=safe(el.getAttribute('data-cl-interest')||el.value,120);
      if(!interestValue)return;
      // A deselection is not positive interest evidence.
      if(el instanceof HTMLInputElement&&/^(checkbox|radio)$/i.test(el.type)&&!el.checked)return;
      if(el.matches('[data-cl-interest], [name*="interest" i], [data-interest]')){
        track('CL | Web | Interest Selected',{
          event_type:'interest_selected',
          selected_interest:interestValue,
          interest:interestValue,
          category_preference:interestValue,
          page_interest:interest(),
          control_name:safe(el.name,80)
        });
      }
    },true);

    document.querySelectorAll('video').forEach(function(video,idx){
      var sent=false;
      var startedAt=0;
      video.addEventListener('play',function(){startedAt=Date.now();});
      video.addEventListener('timeupdate',function(){
        if(sent)return;
        var duration=Number(video.duration||0),current=Number(video.currentTime||0);
        var watchedEnough=current>=30||(duration>0&&current/duration>=0.5);
        if(watchedEnough){
          sent=true;
          track('CL | Web | Video Watched',{
            event_type:'video_watched',
            video_index:idx,
            video_current_seconds:Math.round(current),
            video_duration_seconds:duration?Math.round(duration):null,
            video_percent:duration?Math.round((current/duration)*100):null,
            video_src:safe(video.currentSrc||video.src,500)
          },'video:'+idx+':watched');
        }
      });
    });
  }

  function init(){
    if(started||!production())return;started=true;
    sessionMeta=session();
    attrMeta=attribution();
    // Preserve verified BFCM email-origin attribution on arrival, before any navigation.
    bfcmEmailOrigin();
    identifyKnownCustomer();
    track('CL | Web | Page Viewed',{
      event_type:'page_viewed',
      journey_page_view:true
    },'jpv:'+location.pathname);
    if(ctx.collection&&(ctx.collection.id||ctx.collection.handle))track('CL | Web | Collection Viewed',{},'cv:'+(ctx.collection.handle||''));
    if(ctx.product&&(ctx.product.id||ctx.product.handle))track('CL | Web | Product Viewed',{},'pv:'+(ctx.product.handle||''));
    if(pageType()==='search'){
      var searchParams=new URLSearchParams(location.search),q=safeSearchQuery(searchParams.get('q'));
      if(q){
        var handles=new Set(),filters=[];
        document.querySelectorAll('a[href*="/products/"]').forEach(function(a){try{var m=new URL(a.href,location.origin).pathname.match(/^\/products\/([^/?#]+)/);if(m)handles.add(m[1]);}catch(_){}});
        searchParams.forEach(function(v,k){if(/^filter\./.test(k))filters.push(k+'='+safe(v,120));});
        var resultCount=handles.size;
        track('CL | Web | Search Performed',{search_query:q,search_result_count:resultCount,zero_result_status:resultCount===0,filters:filters.join('|'),sort:safe(searchParams.get('sort_by'),120)},'search:'+q);
      }
    }
    observeSections();observeCards();observeLegacyCompatibleSignals();refreshCart(pageType()==='cart','page');

    var thresholds=[10,30,60,120,300];
    setInterval(function(){
      if(document.visibilityState!=='visible'||!production())return;
      visibleSeconds++;
      thresholds.forEach(function(sec){if(visibleSeconds>=sec)track('CL | Web | Page Engagement',{
          event_type:'page_engaged',
          qualified_engagement:sec>=30,
          engagement_type:'time',
          engagement_seconds:sec,
          duration_seconds:sec,
          time_on_page_seconds:sec,
          scroll_depth:maxScroll,
          campaign:campaign(),
          source:'chris-lake.com',
          placement:pageType(),
          utm_source:attrMeta.latest_utm_source||attrMeta.first_utm_source||''
        },'time:'+sec);});
    },1000);

    window.addEventListener('scroll',function(){
      var d=document.documentElement,den=Math.max(1,d.scrollHeight-innerHeight);
      maxScroll=Math.max(maxScroll,Math.min(100,Math.round((scrollY/den)*100)));
      [25,50,75,90].forEach(function(level){if(maxScroll>=level)track('CL | Web | Page Engagement',{
          event_type:'page_engaged',
          qualified_engagement:visibleSeconds>=30,
          engagement_type:'scroll',
          scroll_depth:level,
          engagement_seconds:visibleSeconds,
          duration_seconds:visibleSeconds,
          time_on_page_seconds:visibleSeconds,
          campaign:campaign(),
          source:'chris-lake.com',
          placement:pageType(),
          utm_source:attrMeta.latest_utm_source||attrMeta.first_utm_source||''
        },'scroll:'+level);});
    },{passive:true});

    window.addEventListener('pagehide',function(){
      sectionState.forEach(function(st,el){if(st.started!==null){st.total+=(performance.now()-st.started)/1000;st.started=null;}if(st.total>=5)track('CL | Web | Section Engagement',Object.assign(sectionInfo(el),{section_seconds:Math.round(st.total),final:true}));});
      if(cartState.quantity>0&&!checkoutIntent)track('CL | Web | Cart Exit With Items',{cart_quantity:cartState.quantity,cart_value:cartState.value,cart_currency:cartState.currency,engagement_seconds:visibleSeconds,scroll_depth:maxScroll});
      track('CL | Web | Page Left',{
        event_type:'page_left',
        qualified_engagement:visibleSeconds>=30,
        engagement_seconds:visibleSeconds,
        duration_seconds:visibleSeconds,
        time_on_page_seconds:visibleSeconds,
        scroll_depth:maxScroll,
        cart_quantity:cartState.quantity,
        cart_value:cartState.value,
        checkout_intent:checkoutIntent,
        campaign:campaign(),
        source:'chris-lake.com',
        placement:pageType(),
        utm_source:attrMeta.latest_utm_source||attrMeta.first_utm_source||''
      },'jpl:'+location.pathname);
    },{once:true});
  }

  document.addEventListener('visitorConsentCollected',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(e){if(!e)init();});
})();